import useSWR, { SWRResponse, SWRConfiguration } from 'swr';
import { AxiosError } from 'axios';
import { MarketingDesignExportJob } from '../../../providers/api/dtos';
import { API_MARKETING_PATH } from '../../../providers/api/api';
import { getMarketingDesignExportJob } from '../../../providers/api/marketing/marketingProvider';

export const MARKETING_DESIGN_EXPORT_JOB_RID = `${API_MARKETING_PATH}/jobs/exports`;

export default function useMarketingDesignExportJob(
  jobId?: string,
  options?: SWRConfiguration<MarketingDesignExportJob, AxiosError>,
): SWRResponse<MarketingDesignExportJob, AxiosError> {
  const key = jobId ? [MARKETING_DESIGN_EXPORT_JOB_RID, jobId] : null;

  return useSWR(key, () => getMarketingDesignExportJob(jobId!), options);
}
